import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { isEmpty, isNumber, isNegative, startCase } from "lodash";
import { toFixedWithoutRounding } from "../../Utils/constants";
import { useContextSelector } from "use-context-selector";
import ToastSky from "./ToastSky";
import BetSlipContext from "../../context/BetSlipContext";
import { Fragment } from "react";
const HeaderSky = ({ setSetting }) => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const setShowBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowBets;
  });

  const toastObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.toastObject
  );
  const setBetSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setBetSlipObject
  );
  const setToastObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setToastObject
  );

  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh
  );
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader
  );
  const setTv = useContextSelector(AuthContext, (ctx) => ctx.setTv);
  const tv = useContextSelector(AuthContext, (ctx) => ctx.tv);
  return (
    <Fragment>
      <header id="header">
        <ul>
          <li className="li-tv_bet">
            {tv?.show && (
              <div
                onClick={() => setTv({ ...tv, status: !tv?.status })}
                id="openTV"
                className={`a-open_tv ui-link ${tv?.status ? "close_tv" : ""}`}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={require("../../assets/images/transparent.gif")} />
              </div>
            )}
            <div
              onClick={() => setShowBets(true)}
              id="openBetsBtn"
              className="a-open_bets ui-link header-a"
              style={{height:"100%"}}
            >
              <img src={require("../../assets/images/transparent.gif")} />
              Bets
            </div>
          </li>
          <li className="main-wallet no-multi">
            <div id="multiWallet" className="a-wallet ui-link header-a">
              <a
                style={{ marginRight: "5px" }}
                className="a-wallet ui-link"
                href="#"
                id="multiWallet"
              >
                <ul
                  style={{
                    display: !refreshAmountLoader ? "flex" : "none",
                    marginRight: "5px",
                  }}
                  id="accountCredit"
                >
                  <li>
                    <span>Main</span>
                    <span id="betCredit">
                      BDT{" "}
                      {isNumber(userCoins?.balance)
                        ? toFixedWithoutRounding(userCoins?.balance, 2)
                        : 0.0}
                    </span>
                  </li>
                  <li>
                    <span>Exposure</span>
                    <span
                      className={userCoins?.exp > 0 ? "red" : ""}
                      id="totalExposure"
                    >
                      ({toFixedWithoutRounding(userCoins?.exp || 0, 2)})
                    </span>
                  </li>
                </ul>
                <p
                  className="loading-bar"
                  id="menuRefreshLoading"
                  style={{ display: refreshAmountLoader ? "flex" : "none" }}
                >
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </p>
              </a>
            </div>
            <div
              onClick={amounutRefresh}
              className="a-refresh ui-link header-a"
              id="menuRefresh"
              title="Refresh Main Wallet"
              style={{height:"100%"}}
            >
              <img src={require("../../assets/images/transparent.gif")} />
            </div>
          </li>
          <li>
            <div
              onClick={() => setSetting(true)}
              className="a-setting ui-link header-a"       style={{height:"100%"}}
              title="Setting"
            >
              <img src={require("../../assets/images/transparent.gif")} />
            </div>
          </li>
        </ul>
        {toastObject?.status && (
          <ToastSky
            type={toastObject?.type}
            sideType={startCase(toastObject?.playType)}
            title={toastObject?.title}
            message={toastObject?.message}
            onClose={() => {
              setToastObject({});
              setBetSlipObject({});
            }}
            playType={toastObject?.playType}
          />
        )}
      </header>
      {/* <div className="marquee-box" style={{ display: "flex" }}>
        <h4>News</h4>
        <div className="marquee">
          <div
            style={{
              width: "100000px",
              "-webkit-transform": "translateX(291px)",
              "-ms-transform": "translateX(291px)",
              transform: "translateX(291px)",
              "-webkit-animation":
                "82.6942s linear 0s infinite normal none running _marqueeAnimation-273792",
              animation:
                "82.6942s linear 0s infinite normal none running _marqueeAnimation-273792",
            }}
            className="js-marquee-wrapper"
          >
            <div
              className="js-marquee"
              style={{ "margin-right": "0px", float: "left" }}
            >
              <a>
                <span>16 Sep 2025</span>Event :- New South Wales Blues v
                Tasmania Tigers : Market :- 26 Over NSWB ''Whole Market Voided
                Because Wrong Rate Offered By Mistake .. Sorry for the
                Inconvenience Caused
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </Fragment>
  );
};

export default HeaderSky;
